const IMAGE_DATA_RENDER_MIN_SIDE = 400;
const IMAGE_DATA_RENDER_MAX_SIDE = 2000;

/**
 * 解析 imageData 数据，支持字符串和对象。
 * @param {Object|string} imageData - 文字素材还原数据。
 * @returns {Object} 解析后的 imageData 对象。
 */
function parseImageDataRenderPayload(imageData) {
  // 字符串 imageData 需要先解析成对象再读取宽高。
  if (typeof imageData === 'string') {
    return JSON.parse(imageData);
  }
  // 对象 imageData 可直接读取宽高，不修改原始数据。
  if (imageData && typeof imageData === 'object') {
    return imageData;
  }
  return {};
}

/**
 * 获取 imageData 前端统一使用的渲染尺寸。
 * @param {Object|string} imageData - 文字素材还原数据。
 * @returns {{sourceWidth:number,sourceHeight:number,width:number,height:number,scale:number}|null} 渲染尺寸；无有效宽高时返回 null。
 */
export function getImageDataLayerRenderSize(imageData) {
  const parsedImageData = parseImageDataRenderPayload(imageData);
  const sourceWidth = Number(parsedImageData && parsedImageData.width);
  const sourceHeight = Number(parsedImageData && parsedImageData.height);
  // imageData 原始尺寸无效时交由调用方继续使用图片真实尺寸兜底。
  if (!(sourceWidth > 0) || !(sourceHeight > 0)) {
    return null;
  }
  const minSide = Math.min(sourceWidth, sourceHeight);
  let scale = 1;
  // 短边小于 400 时，等比放大到 400。
  // if (minSide < IMAGE_DATA_RENDER_MIN_SIDE) {
  //   scale = IMAGE_DATA_RENDER_MIN_SIDE / minSide;
  // }
  // // 短边大于 2000 时，等比缩小到 2000。
  // if (minSide > IMAGE_DATA_RENDER_MAX_SIDE) {
  //   scale = IMAGE_DATA_RENDER_MAX_SIDE / minSide;
  // }
  return {
    sourceWidth,
    sourceHeight,
    width: Math.max(1, Math.round(sourceWidth * scale)),
    height: Math.max(1, Math.round(sourceHeight * scale)),
    scale
  };
}
